import * as actionTypes from "../types/types";

export const initialState = {
  score: 0,
  gameOver: false,
  isPaused: false,
  isGameStarted: false,
  savedGameState: null,
  isStartButtonVisible: true,
  popup: {
    open: false,
  },
  gameWon: false,
  countDown: null,
  remainingLives: 5,
  gameOverMessage: null,
  done: null,
  replay: false,
  togglePauseMessage: { message: "Pause" },
};

const gameReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SCORE:
      return {
        ...state,
        score: action.payload,
      };

    case actionTypes.GAME_OVER:
      return {
        ...state,
        replay: false,
        gameOver: true,
        gameOverMessage:
          state.done === null ? action.payload : state.gameOverMessage,
      };

    case actionTypes.START_GAME:
      return {
        ...state,
        gameOver: false,
        isGameStarted: true,
        savedGameState: null,
      };

    case actionTypes.TOGGLE_START_BUTTON:
      return {
        ...state,
        isStartButtonVisible: !state.isStartButtonVisible,
      };

    case actionTypes.OPEN_POPUP:
      return {
        ...state,
        popup: {
          ...state.popup,
          open: true,
        },
      };

    case actionTypes.CLOSE_POPUP:
      return {
        ...state,
        popup: {
          ...state.popup,
          open: false,
        },
      };

    case actionTypes.GAME_WON:
      return {
        ...state,
        gameWon: true,
      };

    case actionTypes.UPDATE_COUNTDOWN:
      return {
        ...state,
        countDown: action.payload,
      };

    case actionTypes.DECREASE_LIVES:
      return {
        ...state,
        remainingLives: action.payload,
      };

    case actionTypes.GAME_DONE:
      return {
        ...state,
        done: true,
      };

    case actionTypes.BACK_TO_MAIN_MENU:
      return {
        ...initialState,
        gameOver: false,
      };

    case actionTypes.SAVE_GAME_STATE:
      return {
        ...state,
        savedGameState: action.payload,
      };

    case actionTypes.TOGGLE_PAUSE_MESSAGE:
      return {
        ...state,
        togglePauseMessage: action.payload,
      };
    case actionTypes.RESET_GAME:
      return {
        ...initialState,
        replay:true
      };

    default:
      return state;
  }
};

export default gameReducer;
